import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('variant-text-field', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('variant-text-field');

      return new ViewModel(params, element);
    }
  },
  template: html
});
